import { parseTransformString } from '@/features/advices-slider/utils/parseTransformString';

export const stringifyTransformObject = (transform: ReturnType<typeof parseTransformString>) => {
  return Object.entries(transform)
    .map((i) => i[0] + `(${i[1]})`)
    .join(' ');
};
